import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
} from "@angular/core";
import { navigation } from "../../_nav";

@Component({
  selector: "app-sidebar-nav",
  template: ` <nav class="sidebar-nav">
    <ul class="nav">
      <ng-template ngFor let-navitem [ngForOf]="navigation">
        <li *ngIf="isDivider(navitem)" class="nav-divider"></li>
        <ng-template [ngIf]="isTitle(navitem) && isAllowed(navitem)">
          <app-sidebar-nav-title [title]="navitem"></app-sidebar-nav-title>
        </ng-template>
        <ng-template
          [ngIf]="
            !isDivider(navitem) &&
            !isTitle(navitem) &&
            isAllowed(navitem) &&
            hasId(navitem)
          "
        >
          <app-sidebar-nav-item [item]="navitem"></app-sidebar-nav-item>
        </ng-template>
        <ng-container *ngIf="navitem['id']">
          <li *ngIf="navitem['id'] === 'change-password'">
            <app-reset-pwd></app-reset-pwd>
          </li>
          <li
            *ngIf="
              navitem['id'] === 'feedback'
            "
          >
            <div class="row p-0 m-0" style="padding: 0.5rem 0.1rem !important">
              <button
                type="button"
                (click)="feedback()"
                class="btn btn-success bg-transparent border-0 text-left"
                style="font-weight: 500"
              >
                <fa-icon
                  class="white-icon pr-2"
                  [icon]="['fa', navitem['icon']]"
                  style="opacity: 0.5"
                ></fa-icon>
                {{ navitem["name"] }}
              </button>
            </div>
          </li>
        </ng-container>
      </ng-template>

      <li class="text-center text-muted mt-2">
        Version: <strong>{{ version }}</strong>
      </li>
      <li class="text-center text-muted" *ngIf="env !== 'production'">
        Environment: <strong class="text-capitalize">{{ env }}</strong>
      </li>
    </ul>
  </nav>`,
  styleUrls: ["./app-sidebar-nav.component.scss"],
  // providers: [AuthGuard]
  // SocketService,
})
export class AppSidebarNavComponent implements OnInit {
  public navigation = navigation;
  public version = environment.appVersion;
  public environment = environment;
  public badgeCount = 0;
  public env;

  public hasId(item) {
    return typeof item["id"] !== undefined || item["id"] === 'welcome';
  }

  public isDivider(item) {
    return !!item.divider;
  }

  public isTitle(item) {
    return !!item.title;
  }

  public isAllowed(item) {
    return this.authGuard.checkCapabilities(item.url) || item["id"] === 'welcome';
  }

  constructor(
    private authGuard: AuthGuard,
    private feedbackService: FeedbackService,
    private toasterService: ToasterService,
  ) {
    switch (location.hostname) {
      case "localhost":
        this.env = "local";
        break;
      case "employer-stage.tutored.me":
      case "employer-stage.joinrs.com": {
        this.env = "stage";
        break;
      }
      case "employer.tutored.me":
      case "employer.joinrs.com": {
        this.env = "production";
        break;
      }
      default:
        break;
    }
  }

  ngOnInit() { }

  feedback() {
    this.feedbackService.open({
      type: FeedbackType.JOBOFFER,
      modal: {
        title: `Your opinion matters to us!`,
        mainText: `Kindly <span class="text-primary">rate</span> our services based on your overall experience`,
        modalClass: "modal-lg",
        avoidClose: false,
        onSuccess: () =>
          this.toasterService.popAsync(
            "success",
            "Success",
            "Feedback sent correctly."
          ),
        onError: () =>
          this.toasterService.popAsync(
            "error",
            "Error",
            "Internal Server Error, please try again later."
          ),
      },
    });
  }
}

import { Router } from "@angular/router";
import {
  debounceTime,
  distinctUntilChanged,
  map,
  startWith,
  tap,
} from "rxjs/operators";
import { fromEvent } from "rxjs";
import { AuthGuard } from "../../auth/auth.guard";
import { FeedbackService } from "app/feedback/services/feedback.service";
import { FeedbackType } from "app/feedback/models/feedback-config.model";
import { ToasterService } from "angular2-toaster";
import { environment } from "../../../environments/environment";
import { EnvironmentModel } from "environments/environment.model";

@Component({
  selector: "app-sidebar-nav-item",
  template: `
    <li
      *ngIf="!isDropdown(); else dropdown"
      [ngClass]="hasClass() ? 'nav-item ' + item.class : 'nav-item'"
    >
      <app-sidebar-nav-link [link]="item"></app-sidebar-nav-link>
    </li>
    <ng-template #dropdown>
      <li
        [ngClass]="
          hasClass()
            ? 'nav-item nav-dropdown ' + item.class
            : 'nav-item nav-dropdown'
        "
        [class.open]="isActive()"
        routerLinkActive="open"
        appNavDropdown
      >
        <app-sidebar-nav-dropdown [link]="item"></app-sidebar-nav-dropdown>
      </li>
    </ng-template>
  `,
  styleUrls: ["./app-sidebar-nav.component.scss"],
})
export class AppSidebarNavItemComponent {
  @Input() item: any;

  public hasClass() {
    return !!this.item.class;
  }

  public isDropdown() {
    return !!this.item.children;
  }

  public thisUrl() {
    return this.item.url;
  }

  public isActive() {
    return this.router.isActive(this.thisUrl(), false);
  }

  constructor(private router: Router) { }
}

@Component({
  selector: "app-sidebar-nav-link",
  template: `
    <a
      *ngIf="!isExternalLink(); else external"
      [ngClass]="
        hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'
      "
      routerLinkActive="active"
      [routerLink]="[link.url]"
      (click)="toggleOnMobile()"
    >
      <fa-icon
        *ngIf="isIcon()"
        [ngClass]="isActive() ? 'text-primary' : ''"
        [icon]="['fa', link.icon]"
      ></fa-icon>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{
        link.badge.text
      }}</span>
      <div *ngIf="link.hasBadge && badgeCount > 0" class="unread">
        <span>{{ badgeCount }}</span>
      </div>
    </a>
    <ng-template #external>
      <a
        [ngClass]="
          hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'
        "
        href="{{ link.url }}"
      >
        <fa-icon
          *ngIf="isIcon()"
          [ngClass]="isActive() ? 'text-primary' : ''"
          [icon]="['fa', link.icon]"
        ></fa-icon>
        {{ link.name }}
        <span
          *ngIf="isBadge()"
          [ngClass]="'badge badge-' + link.badge.variant"
          >{{ link.badge.text }}</span
        >
      </a>
    </ng-template>
  `,
  styleUrls: ["app-sidebar-nav.component.scss"],
  // providers: [SocketService, ChatService]
})
export class AppSidebarNavLinkComponent implements OnChanges, OnInit {
  @Input() link: any;
  public badgeCount = 0;
  public isMobile: boolean;

  public navigate(url) {
    this.router.navigate(url);
  }

  public toggleOnMobile() {
    if (this.isMobile) {
      document.querySelector("body").classList.toggle("sidebar-mobile-show");
    }
  }

  public hasVariant() {
    return !!this.link.variant;
  }

  public isBadge() {
    return !!this.link.badge;
  }

  public hasBadge() {
    return !!this.link.hasBadge;
  }

  public isExternalLink() {
    return this.link.url.substring(0, 4) === "http";
  }

  public isIcon() {
    return !!this.link.icon;
  }

  public isActive() {
    return this.router.isActive(this.link.url, false);
  }

  constructor(
    // private socketService: SocketService,
    // private chatService: ChatService,
    private router: Router
  ) { }

  ngOnInit() {
    // Create observable from the window event
    // If isMobile enable sidebar toggler on nav click
    fromEvent(window, "resize")
      .pipe(
        debounceTime(200),
        map(() => window.innerWidth),
        distinctUntilChanged(),
        startWith(window.innerWidth),
        tap((width) => {
          this.isMobile = width < 991;
        })
      )
      .subscribe();
  }

  ngOnChanges() {
    // if (this.link.hasBadge) {
    //   this.chatService.getUnreadMessagesBadge().subscribe(badge => {
    //     console.log('unread_messages', badge);
    //     this.badgeCount = badge['unread_messages'];
    //   });
    //   this.socketService.initSocket();
    //   this.socketService.onUpdatedBadgeCount().subscribe(updatedBadge => {
    //     // console.log('updatedBadge', updatedBadge['unread_messages']);
    //     this.badgeCount = updatedBadge['unread_messages'];
    //   });
    // }
  }
}

@Component({
  selector: "app-sidebar-nav-dropdown",
  template: `
    <a class="nav-link nav-dropdown-toggle" appNavDropdownToggle>
      <fa-icon *ngIf="isIcon()" [icon]="['fa', link.icon]"></fa-icon>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{
        link.badge.text
      }}</span>
    </a>
    <ul class="nav-dropdown-items">
      <ng-template ngFor let-child [ngForOf]="link.children">
        <app-sidebar-nav-item [item]="child"></app-sidebar-nav-item>
      </ng-template>
    </ul>
  `,
})
export class AppSidebarNavDropdownComponent {
  @Input() link: any;

  public isBadge() {
    return !!this.link.badge;
  }

  public isIcon() {
    return !!this.link.icon;
  }

  constructor() { }
}

@Component({
  selector: "app-sidebar-nav-title",
  template: "",
})
export class AppSidebarNavTitleComponent implements OnInit {
  @Input() title: any;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    const li = this.renderer.createElement("li");
    const name = this.renderer.createText(this.title.name);

    this.renderer.addClass(li, "nav-title");

    if (this.title.class) {
      const classes = this.title.class;
      this.renderer.addClass(li, classes);
    }

    if (this.title.wrapper) {
      const wrapper = this.renderer.createElement(this.title.wrapper.element);

      this.renderer.appendChild(wrapper, name);
      this.renderer.appendChild(li, wrapper);
    } else {
      this.renderer.appendChild(li, name);
    }
    this.renderer.appendChild(nativeElement, li);
  }
}

export const APP_SIDEBAR_NAV = [
  AppSidebarNavComponent,
  AppSidebarNavDropdownComponent,
  AppSidebarNavItemComponent,
  AppSidebarNavLinkComponent,
  AppSidebarNavTitleComponent,
];
